// src/components/child/offStreetDeviceVisuals.js
//
// Small, framework-agnostic helpers for device type colors/icons. These are
// shared by:
//   - src/pages/OffStreetMasterData.jsx   (tree table row icon color)
//   - src/components/child/PolygonMapEditor.jsx (map marker icons)
//
// Kept in their own file (instead of living inside either of the two above)
// so neither file has to import from the other — that would create a
// circular import (page -> child -> page) which bundlers can resolve
// inconsistently.

export const getDeviceColor = (deviceType) => {
  if (!deviceType) return '#9CA3AF';
  const t = deviceType.toUpperCase();
  if (t === 'APM') return '#8B5CF6';
  if (t === 'EXIT') return '#F59E0B';
  if (t === 'CASHIER') return '#10B981';
  if (t === 'APP') return '#06B6D4';
  if (t === 'HHD') return '#F97316';
  if (t === 'BOOKING') return '#EC4899';
  if (t === 'VALIDATION') return '#14B8A6';
  if (t === 'ENTRY') return '#3B82F6';
  if (t === 'POS') return '#84CC16';
  if (t === 'VALIDATOR') return '#EF4444';
  return '#6366F1';
};

export const getDeviceTypeName = (deviceType) => (deviceType ? String(deviceType).toUpperCase() : '—');

export const MARKER_ICON_PATHS = {
  APM: '<path d="M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8"/><path d="M10 19v-3.96 3.15"/><path d="M7 19h5"/><rect width="6" height="10" x="16" y="12" rx="2"/>',
  EXIT: '<path d="m16 17 5-5-5-5"/><path d="M21 12H9"/><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>',
  CASHIER: '<rect width="20" height="12" x="2" y="6" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/>',
  APP: '<rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/>',
  HHD: '<rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><line x1="12" x2="12.01" y1="18" y2="18"/>',
  BOOKING: '<path d="M8 2v3"/><path d="M16 2v3"/><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18"/><path d="m9 15 2 2 4-4"/>',
  VALIDATION: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/>',
  ENTRY: '<path d="m10 17 5-5-5-5"/><path d="M15 12H3"/><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>',
  POS: '<rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/>',
  VALIDATOR: '<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/>',
  DEFAULT: '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="1"/>',
};

export const getMarkerIconPaths = (deviceType) =>
  (deviceType && MARKER_ICON_PATHS[deviceType.toUpperCase()]) || MARKER_ICON_PATHS.DEFAULT;
